import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.49989 13.475L4.02489 9.99999L2.84155 11.175L7.49989 15.8333L17.4999 5.83333L16.3249 4.65833L7.49989 13.475Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
